export default __webpack_public_path__ + "static/media/home.c98ae34d.jpeg";